import {
    Radar,
    RadarChart,
    PolarGrid,
    PolarAngleAxis,
    ResponsiveContainer,
    PolarRadiusAxis,
} from "recharts";
import Card from "../Card";
import Typography from "../Typography";
import ComplianceSpiderTick from "./ComplianceSpiderTick";

export type ComplianceSpiderItem = {
    label: string;
    period1: number;
    period2: number;
};

export type ComplianceSpiderProps = {
    title: string;
    period1Label: string;
    period2Label: string;
    data: ComplianceSpiderItem[];
};

const ComplianceSpider = ({
    title,
    period1Label,
    period2Label,
    data,
}: ComplianceSpiderProps) => {
    const _data = data.map((d) => ({
        ...d,
        fullMark: 4,
    }));

    return (
        <Card className="h-[330px] bg-white border-surface-light-5 border-2 p-12 pt-6">
            <Typography
                variant="title-small"
                component="h3"
                className="-ml-6 mb-2"
            >
                {title}
            </Typography>
            <ResponsiveContainer width="100%" height="100%">
                <RadarChart cx="50%" cy="50%" outerRadius="80%" data={_data}>
                    <PolarGrid />
                    <PolarRadiusAxis
                        angle={30}
                        domain={[0, 4]}
                        tick={() => <></>}
                        stroke="rgba(0, 0, 0, 0)"
                    />
                    <PolarAngleAxis
                        dataKey="label"
                        tick={ComplianceSpiderTick}
                    />
                    <Radar
                        name={period1Label}
                        dataKey="period1"
                        stroke="#54D7F2"
                        fill="#54D7F2"
                        fillOpacity={0.18}
                    />
                    <Radar
                        name={period2Label}
                        dataKey="period2"
                        stroke="#8EB85B"
                        fill="#8EB85B"
                        fillOpacity={0.18}
                    />
                </RadarChart>
            </ResponsiveContainer>
        </Card>
    );
};

export default ComplianceSpider;
